import { produce } from 'immer';

import { SLIDER_ADD, SLIDER_MOVE, SLIDER_MOVE_LEFT, SLIDER_MOVE_RIGHT, SLIDER_SET_MIRROR_MODE } from './actions';

export const defaultState = {
    prevSlide: 0,
    slidesCount: 0,
    activeSlide: 0,
    direction: 'right',
    isMirrorMode: false
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SLIDER_ADD:
        case SLIDER_ADD + reducerSuffix: {
            const { slidesCount, activeSlide, prevSlide } = action.payload;

            Object.assign(draftState, {
                prevSlide,
                slidesCount,
                activeSlide
            });

            break;
        }

        case SLIDER_MOVE:
        case SLIDER_MOVE + reducerSuffix: {
            const { activeSlide, prevSlide } = action.payload;

            Object.assign(draftState, {
                prevSlide,
                activeSlide,
                direction: draftState.isMirrorMode
                    ? activeSlide > prevSlide ? 'left' : 'right'
                    : activeSlide > prevSlide ? 'right' : 'left'
            });

            break;
        }

        case SLIDER_MOVE_LEFT:
        case SLIDER_MOVE_LEFT + reducerSuffix: {
            const { activeSlide, slidesCount } = draftState;

            if (draftState.isMirrorMode) {
                Object.assign(draftState, {
                    direction: 'left',
                    prevSlide: activeSlide,
                    activeSlide: activeSlide === slidesCount - 1 ? 0 : activeSlide + 1
                });

                break;
            }

            Object.assign(draftState, {
                direction: 'left',
                prevSlide: activeSlide,
                activeSlide: activeSlide ? activeSlide - 1 : slidesCount - 1
            });

            break;
        }

        case SLIDER_MOVE_RIGHT:
        case SLIDER_MOVE_RIGHT + reducerSuffix: {
            const { activeSlide, slidesCount } = draftState;

            if (draftState.isMirrorMode) {
                Object.assign(draftState, {
                    direction: 'right',
                    prevSlide: activeSlide,
                    activeSlide: activeSlide ? activeSlide - 1 : slidesCount - 1
                });

                break;
            }

            Object.assign(draftState, {
                direction: 'right',
                prevSlide: activeSlide,
                activeSlide: activeSlide === slidesCount - 1 ? 0 : activeSlide + 1
            });

            break;
        }

        case SLIDER_SET_MIRROR_MODE:
        case SLIDER_SET_MIRROR_MODE + reducerSuffix: {
            Object.assign(draftState, {
                isMirrorMode: action.isMirrorMode
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);

